import React from "react";
import "./AdminRecipient.css";

class AdminRecipient extends React.Component {
    constructor(props) {
        super(props);

        this.renderApproval = this.renderApproval.bind(this);
        this.handleApproval = this.handleApproval.bind(this);
        this.handlePaid = this.handlePaid.bind(this);
    }

    handleApproval(event) {
        let id = event.target.id.split("-")[0];
        this.props.approve(id);
    }

    handlePaid(event) {
        let id = event.target.id.split("-")[0];
        this.props.markPaid(id);
    }

    renderApproval() {
        if(this.props.recipient.approved) {
            return (
                <div className="half recipient-bottom">
                    <p>Paid?</p>
                    <input id={`${this.props.recipient._id}-approve`} className="paid-indicator" onChange={this.handlePaid} type="checkbox" defaultChecked={this.props.recipient.paid}/>
                </div>
            )
        } else {
            return (
                <div onClick={this.handleApproval} className="approval-button" id={`${this.props.recipient._id}-approve`}>APPROVE</div>
            );
        }
    }

    render() {
        return (
            <div className="recipient">
                <div className="half recipient-top">
                    <h3>{this.props.recipient.name},</h3>
                    <h4>{this.props.recipient.email}</h4>
                </div>
                {this.renderApproval()}
            </div>
        )
    }
}

export default AdminRecipient;